export const RunPayout = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9098 17.3404C14.5335 17.5483 15.2098 17.2256 15.4406 16.6101C15.6838 15.9616 15.34 15.2407 14.6828 15.0216L9.3726 13.2647C8.24155 12.8876 6.08265 12.815 4.625 14.2726"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.626 14.2723H2.18164V20.3832H4.626V14.2723Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.625 19.161L10.1655 20.42C10.9944 20.6098 11.8837 20.719 12.734 20.7091C14.9342 20.6833 17.0736 19.9656 18.8641 18.6867L21.3051 16.8783C21.8757 16.4709 21.9871 15.6679 21.5491 15.1204C21.1436 14.6136 20.4126 14.5121 19.8844 14.8894L17.2254 16.8536C16.2709 17.5354 15.0477 17.7194 13.9348 17.3484L10.1657 16.1056"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9927 9.72626C16.7594 10.3013 18.2247 9.89415 18.2247 9.0781C18.2247 7.72531 15.6348 8.59762 15.6348 7.24483C15.6348 6.42511 17.1026 6.0235 17.8668 6.59667"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9297 10.6873V9.99469"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9297 6.32812V5.63556"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.8185 8.16145C21.8185 10.8614 19.6297 13.0502 16.9297 13.0502C14.2298 13.0502 12.041 10.8614 12.041 8.16145C12.041 5.46149 14.2298 3.27273 16.9297 3.27273C19.6297 3.27273 21.8185 5.46149 21.8185 8.16145Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
